import React from 'react';

const ViseEmoji = () => {
  return (
    <svg
      width="29"
      height="33"
      viewBox="0 0 29 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.91975 32.1111C10.3976 32.1111 11.5957 30.9131 11.5957 29.4352C11.5957 27.9573 10.3976 26.7593 8.91975 26.7593C7.44188 26.7593 6.24383 27.9573 6.24383 29.4352C6.24383 30.9131 7.44188 32.1111 8.91975 32.1111Z"
        fill="#67757F"
      />
      <path
        d="M25.8673 32.1111C27.3452 32.1111 28.5432 30.9131 28.5432 29.4352C28.5432 27.9573 27.3452 26.7593 25.8673 26.7593C24.3894 26.7593 23.1914 27.9573 23.1914 29.4352C23.1914 30.9131 24.3894 32.1111 25.8673 32.1111Z"
        fill="#67757F"
      />
      <path
        d="M8.91975 28.5432H25.8673V30.3272H8.91975V28.5432Z"
        fill="#67757F"
      />
      <path
        d="M15.1636 13.8274C15.1636 12.5956 16.1617 12.4894 17.3935 12.4894C18.6253 12.4894 19.6235 12.5956 19.6235 13.8274V29.8812C19.6235 31.113 18.6253 32.1111 17.3935 32.1111C16.1617 32.1111 15.1636 31.113 15.1636 29.8812V13.8274Z"
        fill="#9AAAB4"
      />
      <path
        d="M21.4074 13.3814C21.4074 14.3662 20.6082 15.1654 19.6235 15.1654H15.1636C14.1788 15.1654 13.3796 14.3662 13.3796 13.3814C13.3796 12.3958 14.1788 12.4894 15.1636 12.4894H19.6235C20.6082 12.4894 21.4074 12.3967 21.4074 13.3814Z"
        fill="#67757F"
      />
      <path
        d="M22.2994 24.0833C22.2994 25.0681 21.5002 25.8673 20.5154 25.8673H14.2716C13.2869 25.8673 12.4877 25.0681 12.4877 24.0833V19.6235C12.4877 18.6387 13.2869 17.8395 14.2716 17.8395H20.5154C21.5002 17.8395 22.2994 18.6387 22.2994 19.6235V24.0833ZM22.2994 4.45988C22.2994 5.44462 21.5002 6.24383 20.5154 6.24383H14.2716C13.2869 6.24383 12.4877 5.44462 12.4877 4.45988V3.5679C12.4877 2.58227 13.2869 1.78395 14.2716 1.78395H20.5154C21.5002 1.78395 22.2994 2.58227 22.2994 3.5679V4.45988Z"
        fill="#DA2F47"
      />
      <path
        d="M8.91975 19.6235C7.93501 19.6235 7.1358 18.8242 7.1358 17.8395V6.24383C7.1358 5.25909 7.93501 4.45988 8.91975 4.45988H22.2994V3.5679C22.2994 1.59753 20.7019 0 18.7315 0H3.5679C1.59753 0 0 1.59753 0 3.5679V20.5154C0 22.4858 1.59753 24.0833 3.5679 24.0833H16.0556C18.0259 24.0833 19.6235 22.4858 19.6235 20.5154V19.6235H8.91975Z"
        fill="#DA2F47"
      />
      <path
        d="M5.35185 17.8395C5.35185 18.8242 4.55264 19.6234 3.5679 19.6234C2.58316 19.6234 1.78395 18.8242 1.78395 17.8395V6.24382C1.78395 5.25908 2.58316 4.45987 3.5679 4.45987C4.55264 4.45987 5.35185 5.25908 5.35185 6.24382V17.8395Z"
        fill="#E75A70"
      />
    </svg>
  );
};

export default ViseEmoji;
